// Shared task quick-action helpers (Tasks page, Dashboard, Focus mode).

export const EXIT_MS = 420; // matches .sw-exit-* + .sw-collapse in index.css
export const wait = (ms) => new Promise((r) => setTimeout(r, ms));

const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

// One-tap reschedule targets, relative to now.
export function snoozeOptions(now = new Date()) {
  const at = (days, hour) => { const d = addDays(startOfDay(now), days); d.setHours(hour, 0, 0, 0); return d; };
  const opts = [
    { key: "1h", label: "In 1 hour", date: new Date(now.getTime() + 3600e3) },
    { key: "3h", label: "In 3 hours", date: new Date(now.getTime() + 3 * 3600e3) },
  ];
  if (now.getHours() < 17) opts.push({ key: "eve", label: "This evening", date: at(0, 18) });
  opts.push({ key: "tom", label: "Tomorrow morning", date: at(1, 9) });
  const toMonday = ((8 - now.getDay()) % 7) || 7;
  opts.push({ key: "mon", label: "Next Monday", date: at(toMonday, 9) });
  return opts;
}

export const shortWhen = (d) => d.toLocaleString("en-US", { weekday: "short", hour: "numeric", minute: "2-digit" });

export const shortTitle = (t) => (t.title.length > 50 ? t.title.slice(0, 49) + "…" : t.title);

// "Overdue 3 h", "in 45 min", "today 6:00 PM" — compact due text for small rows.
export function dueShort(iso, now = new Date()) {
  if (!iso) return { text: "No deadline", tone: "slate" };
  const d = new Date(iso);
  const ms = d - now;
  const mins = Math.round(Math.abs(ms) / 60000);
  const span = mins < 60 ? `${mins} min` : mins < 1440 ? `${Math.floor(mins / 60)} h` : `${Math.round(mins / 1440)} d`;
  if (ms < 0) return { text: `Overdue ${span}`, tone: "red" };
  if (mins < 120) return { text: `in ${span}`, tone: "amber" };
  const sameDay = d.toDateString() === now.toDateString();
  const time = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  return { text: sameDay ? `today ${time}` : `${d.toLocaleDateString("en-US", { weekday: "short", day: "numeric", month: "short" })} ${time}`, tone: "slate" };
}
